import {
  GET_SCHEDULED_LIST_SUCCESS,
  GET_SCHEDULED_LIST_FAIL,
  GET_SCHEDULED_DETAIL,
  GET_SCHEDULED_DETAIL_SUCCESS,
  GET_SCHEDULED_DETAIL_FAIL,
  CANCEL_SCHEDULED_SUCCESS,
  CANCEL_SCHEDULED_FAIL,
  FREEZE_SCHEDULED_SUCCESS,
  FREEZE_SCHEDULED_FAIL,
  RESET_SCHEDULED_FLAG,
} from "./actionTypes"

const INIT_STATE = {
  scheduledList: [],
  scheduledTotal: 0,
  scheduledTotalPages: 0,
  scheduledDetail: null,
  detailLoading: false,
  cancelled: false,
  frozen: false,
  error: {},
}

const scheduled = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SCHEDULED_LIST_SUCCESS:
      // payload is { rows, total, totalPages } (or a bare array, back-compat).
      return {
        ...state,
        scheduledList: Array.isArray(action.payload) ? action.payload : action.payload.rows,
        scheduledTotal: Array.isArray(action.payload)
          ? action.payload.length
          : action.payload.total ?? 0,
        scheduledTotalPages: Array.isArray(action.payload) ? 1 : action.payload.totalPages ?? 0,
      }
    case GET_SCHEDULED_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_SCHEDULED_DETAIL:
      return {
        ...state,
        detailLoading: true,
        scheduledDetail: null,
      }
    case GET_SCHEDULED_DETAIL_SUCCESS:
      return {
        ...state,
        scheduledDetail: action.payload,
        detailLoading: false,
      }
    case GET_SCHEDULED_DETAIL_FAIL:
      return {
        ...state,
        detailLoading: false,
        error: action.payload,
      }
    case CANCEL_SCHEDULED_SUCCESS:
      return {
        ...state,
        cancelled: true,
      }
    case CANCEL_SCHEDULED_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case FREEZE_SCHEDULED_SUCCESS:
      return {
        ...state,
        frozen: true,
      }
    case FREEZE_SCHEDULED_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_SCHEDULED_FLAG:
      return {
        ...state,
        cancelled: false,
        frozen: false,
      }
    default:
      return state
  }
}

export default scheduled
